export default "__VITE_ASSET__tRxjpdBJ__"